import React, { ReactNode } from 'react'

import { DiscoverMoreButton } from './buttons/DiscoverMoreButton'
import { HorizontalLine } from './HorizontalLine'
import { ColorTypeBackground } from './types'

interface SectionTextProps {
    title: string
    className?: string
    hrLineColor: ColorTypeBackground
    hrLineClassName?: string
    discoverMore?: boolean
    discoverMoreLink?: string
    children: ReactNode
}

export const SectionText: React.FC<SectionTextProps> = ({
    title,
    className,
    hrLineColor,
    hrLineClassName,
    discoverMore,
    discoverMoreLink,
    children,
}) => {
    return (
        <div className={className}>
            <h1 className="text-xl font-bold">{title}</h1>
            <HorizontalLine color={hrLineColor} className={hrLineClassName} />
            <div>{children}</div>
            {discoverMore && discoverMoreLink && (
                <DiscoverMoreButton link={discoverMoreLink} className="mt-4 bg-primary-orange" />
            )}
        </div>
    )
}
